const mutations = {
  isForgotPasswordMailSent: (state, payload) => {
    state.isForgotPasswordMailSent = payload
  },
  authenticate: (state, payload) => {
    state.isAuthenticated = true
  },
  authenticateFromToken: (state, payload) => {
    state.isAuthenticated = true
  },
  unauth: state => {
    state.isAuthenticated = false
  },
  sendForgotPasswordMail: (state, payload) => {},

  setAuthToken: (state, payload) => (state.authToken = payload),
  setUserInfo: (state, payload) => (state.userInfo = payload)
}

export default mutations
